<template>
    <app-layout ref="lo" title="Dashboard">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-12 mx-auto">
<!--                            buat dialog dengan input tanggal-->
                            <Dialog header="Undang Klarifikasi" :visible="displayBasic" :modal="true" :closable="false" :style="{ width: '50vw' }">
                                <div class="p-fluid px-3 mb-3">
                                    <div class="p-field">
                                        <JetLabel
                                            class="w-full"
                                            for="tanggal"
                                            value="Tanggal Undangan"
                                        />
                                        <Input
                                            id="tanggal"
                                            v-model="tanggal"
                                            type="datetime-local"
                                            placeholder=""
                                            class="mt-1 block w-full"
                                        />
                                    </div>
                                </div>
                                <div class="p-fluid px-3 mb-3">
                                    <div class="p-field">
                                        <JetLabel
                                            class="w-full"
                                            for="lokasi"
                                            value="Lokasi Klarifikasi"
                                        />
                                        <Input
                                            id="lokasi"
                                            v-model="lokasi"
                                            type="text"
                                            placeholder=""
                                            class="mt-1 block w-full"
                                        />
                                    </div>
                                </div>
                                <div class="p-fluid px-3 mb-3">
                                    <div class="p-field">
                                        <JetLabel
                                            class="w-full"
                                            for="keterangan"
                                            value="Keterangan Klarifikasi"
                                        />
                                        <Input
                                            id="keterangan"
                                            v-model="keterangan"
                                            type="text"
                                            placeholder=""
                                            class="mt-1 block w-full"
                                        />
                                    </div>
                                </div>
                                <div class="p-fluid px-3 mb-3">
                                    <div class="p-field">
                                        <JetLabel
                                            class="w-full"
                                            for="no_hp"
                                            value="Contact Person"
                                        />
                                        <Input
                                            id="no_hp"
                                            v-model="no_hp"
                                            type="text"
                                            placeholder=""
                                            class="mt-1 block w-full"
                                        />
                                    </div>
                                </div>
                                <template #footer>
                                    <div class="p-d-flex p-jc-end">
                                        <Button label="Batal" @click="displayBasic=false" />
                                        <Button label="Undang" @click="undangKlarifikasi" />
                                    </div>
                                </template>
                            </Dialog>
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <Toolbar>
                                    <template #start>
                                        <!-- <ButtonLinkAdd
                                            :url="
                                                route('penyedia.create')
                                            "
                                            class="mr-1"
                                            >Tambah</ButtonLinkAdd
                                        > -->
                                        <ButtonAdd
                                            :disabled="
                                                selected_penyedia.length == 0 ||
                                                !allow_to_proceed
                                            "
                                            label="Verifikasi"
                                            @click="verif($event)"
                                            class="mr-1"
                                        />
                                        <ButtonEdit
                                            :disabled="
                                                selected_penyedia.length == 0 ||
                                                !allow_to_proceed
                                            "
                                            label="Undang Klarifikasi"
                                            @click="undang($event)"
                                            class="mr-1"
                                        />
                                        <!-- <ButtonLinkEdit
                                            :disabled="
                                                selected_penyedia.length != 1
                                            "
                                            :url="
                                                route('penyedia.edit', {
                                                    id: selected_penyedia_id,
                                                })
                                            "
                                            class="mr-1"
                                            >Edit</ButtonLinkEdit
                                        > -->
                                    </template>
                                    <template #end>
                                    </template>
                                </Toolbar>
                            </div>
                            <div class="w-full mb-20">
                                <EzDataTable
                                    ref="ezdt"
                                    :config="ezdtConfig"
                                    @getSelectedData="getSelectedpenyedia"
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import EzDataTable from "@/Components/EzDataTable";
import Toolbar from "primevue/toolbar";
import Button from "primevue/button";
import ButtonLinkAdd from "@/Components/ButtonLinkAdd";
import ButtonLinkEdit from "@/Components/ButtonLinkEdit";
import ButtonLinkShow from "@/Components/ButtonLinkShow";
import ButtonDelete from "@/Components/ButtonDelete";
import ButtonEdit from "@/Components/ButtonEdit.vue";
import ButtonAdd from "@/Components/ButtonAdd.vue";
import Dialog from 'primevue/dialog';
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input";
import { Pesan } from "@/constants";

export default defineComponent({
    components: {
        AppLayout,
        BreadCrumb,
        EzDataTable,
        Toolbar,
        Button,
        ButtonLinkAdd,
        ButtonLinkEdit,
        ButtonLinkShow,
        ButtonDelete,
        ButtonEdit,
        ButtonAdd,
        Dialog,
        JetLabel,
        Input,
    },
    data() {
        return {
            ezdtConfig: {
                dtHeader: "Daftar Penyedia",
                globalFilter: ["nama_perusahaan"],
                sortBy: "created_at",
                defineCols: [
                    {
                        field: "status",
                        header: "Status",
                        style: "min-width: 5rem",
                        isFrozen: true,
                        col_type: "status",
                    },
                    {
                        field: "nama_perusahaan",
                        header: "Nama",
                        style: "min-width: 20rem",
                        isFrozen: true,
                        col_type: "text",
                    },
                    {
                        field: "npwp_perusahaan",
                        header: "NPWP",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },
                    {
                        field: "nama_jenis_pekerjaan",
                        header: "Jenis Pekerjaan",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },
                    {
                        field: "nama_pemberi_kuasa",
                        header: "Direktur",
                        style: "min-width: 10rem",
                        col_type: "text",
                    },
                    {
                        field: "nama_penerima_kuasa",
                        header: "Nama Penerima Kuasa",
                        style: "min-width: 10rem",
                        col_type: "text",
                    },
                    {
                        field: "alamat_perusahaan",
                        header: "Alamat",
                        style: "min-width: 10rem",
                        col_type: "text",
                    },
                    {
                        field: "alamat_perusahaan_semarang",
                        header: "alamat_perusahaan_semarang",
                        style: "min-width: 10rem",
                        col_type: "text",
                    },
                ],
                dtSourceApiRoute: {
                    list: "penyedia.data",
                    show: "penyedia.showPenyedia",
                    // edit: "penyedia.edit",
                    // destroy: "penyedia.destroy",
                },
            },
            selected_penyedia: [],
            selected_penyedia_id: 0,
            allow_to_proceed: true,
            displayBasic: false,
            tanggal: null,
            keterangan: null,
            lokasi: null,
        };
    },
    methods: {
        loadEzData: function () {
            // this.allow_to_proceed = false;
            this.$refs.ezdt.loadData();
        },
        getSelectedpenyedia: function (data) {
            this.selected_penyedia = data;
            this.selected_penyedia_id = 0;
            if (data.length == 1) {
                this.selected_penyedia_id = data[0]["user_id"];
                console.log(this.selected_penyedia_id);
            }
        },
        tambah: function (event) {
            //
        },
        edit: function (event) {
            //
        },

        verif: function (event) {
            this.$confirm.require({
                target: event.currentTarget,
                message:
                    "Verifikasi (" +
                    this.selected_penyedia.length +
                    ") selected record ?",
                icon: "pi pi-info-circle",
                acceptClass: "p-button-info",
                accept: () => {
                    let ids = [];
                    let cek = true;
                    this.selected_penyedia.forEach(function (item, index) {
                        ids.push(item.id);
                        // cek jika ada item.status is verifikasi so return toast
                        if(item.status == '3'){
                           cek = false;
                        }
                    });
                    // update data
                    if (cek == false){
                        this.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: 'data sudah diverifikasi',
                            life: 3000,
                        });
                        return false;
                    }
                    axios
                        .post(route("penyedia.verifikasi"), {
                            ids: ids,
                            status: 3,
                            keterangan: '-',
                        })
                        .then((response) => {
                            this.$toast.add({
                                severity: "success",
                                summary: "Success",
                                detail: Pesan.success,
                                life: 3000,
                            });
                            this.loadEzData();
                        })
                        .catch((error) => {
                            this.$toast.add({
                                severity: "error",
                                summary: "Error",
                                detail: Pesan.error,
                                life: 3000,
                            });
                        });
                },
                reject: () => {
                    //
                },
            });

        },
        undang: function (event) {

            let ids = [];
            this.selected_penyedia.forEach(function (item, index) {
                ids.push(item.id);
            });
            // tampilkan modal
            this.displayBasic = true;

        },
        undangKlarifikasi: function (event) {
            let ids = [];
            this.selected_penyedia.forEach(function (item, index) {
                ids.push(item.id);
            });
            // update data
            // console.log(this.tanggal);
            axios
                .post(route("penyedia.undangKlarifikasi"), {
                    ids: ids,
                    tanggal: this.tanggal,
                    lokasi: this.lokasi,
                    keterangan: this.keterangan,
                    no_hp: this.no_hp,
                })
                .then((response) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Success",
                        detail: Pesan.success,
                        life: 3000,
                    });
                    this.loadEzData();
                    this.displayBasic = true;
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: Pesan.error,
                        life: 3000,
                    });
                });

        },
    },
});
</script>
